import { RESET, SET_SELECTED_PROGRESS } from "./progressFilter.actionTypes";
import { PROGRESS_VALUES } from "./progressFilter.constants";

const initialState = {
  // Default all-on so the board opens unfiltered.
  selectedProgress: [...PROGRESS_VALUES],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_PROGRESS: {
      return { ...state, selectedProgress: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
